<script>
  /* Executable code section of the program */
  //Component importation
  import CardPrueba from "../components/Cards/AttendeSocialCard.svelte";
  import Loader from "../components/Loader.svelte";
  import EventHomeComponent from "../components/EventHomeComponent.svelte";
  import EmptyCurrentEvent from "../components/EmptySections/EmptyCurrentEvent.svelte";
  import EventHomeCard from "../components/Cards/EventHomeCard.svelte";
  import EmptyEvents from "../components/EmptySections/EmptyEvents.svelte";

  //Tools importation
  import { isProtectedRoute, userLocalData } from "../apis/storage";
  import {
    auth,
    getSpecificDocuments,
    getClosestEvent,
    getLast4PastEvents,

    updateDocument,

    getCollection


  } from "../apis/APIS";
  import { onAuthStateChanged } from "firebase/auth";
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";

  //Auxiliary Variables
  let isLoadedContent = false;
  let currentEvent =  [];
  let pastEvent = [];
  let eventAttende = [];
  let closeEvents = []
  let allEvents = []

  //Function to get the current date
  const getCurrentFormattedDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Ensure two digits
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`; // Format: YYYY-MM-DD
  };

  //Function to push de event to past events
  function isPastDate(dateString) {
    const inputDate = new Date(dateString);
    const todayDate = new Date();
    
    // Remove time to compare only YYYY-MM-DD
    todayDate.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);

    return todayDate > inputDate;
}


  //Logged-in session verification
  //Initial function execution
  onMount(async () => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        
    window.scrollTo({ top: 0, behavior: "smooth" });
        $isProtectedRoute = true;
        $userLocalData = await getSpecificDocuments("users","email",user.email)
        
        if ($userLocalData[0].userRole !== "attendee") {
          closeEvents = await getClosestEvent(getCurrentFormattedDate(), 4) || [];
          eventAttende = closeEvents
          currentEvent = closeEvents[0]
          
          //get all events
          allEvents = await getCollection("events")
          
          /* pastEvent = await getLast4PastEvents("events") */
          
        } else {
          /* $userLocalData[0].pastEvents.forEach(async(element) => {
            let event = await getSpecificDocuments("events","tittle",element)
            pastEventsAttendee.push(event[0])
          }); */
          let actualEvent = await getSpecificDocuments(
            "events",
            "tittle",
            $userLocalData[0].event
          );
          eventAttende = actualEvent[0]         
          
          if (isPastDate(eventAttende.eventDate.endDate)) {
            /* Agregar aqui funcion para colocar evento en el pasado */
            const exists = $userLocalData[0].pastEvents.some(user => user.id === eventAttende.id);
            if (!exists) {
            $userLocalData[0].pastEvents.push(eventAttende)
            updateDocument("users",$userLocalData[0],$userLocalData[0].id)
            }
            currentEvent = []
          }
          else{
          currentEvent = actualEvent[0]
          }
        }
        setTimeout(() => (isLoadedContent = true), 1500);
      } else {
        navigate("/");
      }
    });
  });
  /* End of the section */
</script>

<!-- Section to place the HTML code -->
{#if $isProtectedRoute}
  {#if isLoadedContent}
    <body>
      <!-- Principal event section -->
      <div class="upcomungEventContainer">
        {#if eventAttende === undefined || eventAttende === null || eventAttende.length == 0}
          <EmptyCurrentEvent />
        {:else}
          <div class="tittleContainer">
            {#if $userLocalData[0].userRole == "attendee"}
              <h1>My Next Event:</h1>
            {:else}
              <h1>Upcoming event:</h1>
            {/if}
          </div>
          {#if $userLocalData[0].userRole !== "attendee"}
          <div class="componentContainer">
            <EventHomeComponent eventInfo={currentEvent} />
          </div>
            {:else}
              {#if Object.keys(currentEvent).length > 0}
                <div class="componentContainer">
                  <EventHomeComponent eventInfo={currentEvent} />
                </div>
              {:else}
                <EmptyEvents/>
              {/if}
          {/if}
        {/if}
      </div>
      <!-- End section -->
      <!-- More event section -->
      <div class="moreEventsSection">
        {#if $userLocalData[0].userRole == "attendee"}
          <div class="tittleContainer">
            <h1>Previous Events:</h1>
          </div>
          <div class="contentContainer">
            {#if $userLocalData[0].pastEvents.length == 0}
            <EmptyEvents/>  
              {:else}
              {#each $userLocalData[0].pastEvents as event, index}
                  <EventHomeComponent eventInfo={event} />
              {/each}
            {/if}
          </div>
        {:else}
          <div class="tittleContainer">
            <h1>Events:</h1>
          </div>
          <div class="contentContainer">
            {#if allEvents.length > 0}
            {#each allEvents as event, index}
              <div class="componentContainer">
            <EventHomeComponent eventInfo={event} />
          </div>
            {/each}
              {:else}
              <EmptyEvents/>  
            {/if}
          </div>
        {/if}
      </div>
      <!-- End section -->
    </body>
  {:else}
    <Loader />
  {/if}
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  body {
    width: 100%;
    background-color: #f4f4f4;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
  }
  .upcomungEventContainer {
    width: 90%;
    background-color: white;
    height: auto;
    padding: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .tittleContainer {
    width: 90%;
    padding: 15px;
  }
  .componentContainer {
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .moreEventsSection {
    background-color: white;
    width: 90%;
    height: auto;
    padding: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .contentContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 90%;
    height: auto;
    padding: 20px;
  }
  h1{
    font-size: 40px;
    border-bottom: 1px solid gray;
    padding: 20px;
    font-weight: 500;
  }

  

/* /////////Tablets///////// */
@media (min-width: 700px) and (max-width: 1100px) {
    
  .contentContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 90%;
    height: auto;
    padding: 20px;
  }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    body{
      padding: 10px;
    }
    .upcomungEventContainer {
    width: 100%;
    background-color: white;
    padding: 10px;
  }
  .moreEventsSection{
    padding: 5px;
  }
  .contentContainer{
    padding: 5px;
    flex-direction: column;
  }
  h1{
    font-size: 25px;
    border-bottom: 1px solid gray;
    padding: 20px 0;
    font-weight: 500;
  }
  }

  /* End of the section */
</style>
